<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回">
      </f7-nav-left>
      <f7-nav-title>设置管理人员</f7-nav-title>
      <f7-nav-right v-if="perms.projectManagerSet">
        <f7-link @click="add">&nbsp;保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
      <div v-if="!perms.projectManagerSet">
        <manager-view :manager="manager" :project-id="projectId"></manager-view>
      </div>
      <f7-list inline-labels v-if="perms.projectManagerSet">
        <f7-list-item title="项目经理" link="" @click="pmPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.pm.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="pmPopupOpened"
            @popup:closed="pmPopupOpened = false">
            <worker-list
              title="选择项目经理"
              :opened="pmPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.pm">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="项目副经理" link="" @click="dpmPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.dpm.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="dpmPopupOpened"
            @popup:closed="dpmPopupOpened = false">
            <worker-list
              title="选择项目副经理"
              :opened="dpmPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.dpm">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="技术负责人" link="" @click="techLeaderPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.techLeader.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="techLeaderPopupOpened"
            @popup:closed="techLeaderPopupOpened = false">
            <worker-list
              title="选择技术负责人"
              :opened="techLeaderPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.techLeader">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="专业工长" link="" @click="professionLeaderPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.professionLeader.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="professionLeaderPopupOpened"
            @popup:closed="professionLeaderPopupOpened = false">
            <worker-list
              title="选择专业工长"
              :opened="professionLeaderPopupOpened"
              :project-id.sync="projectId"
             :result.sync="manager.professionLeader">
             </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="质量员" link="" @click="qualityInspectorPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.qualityInspector.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="qualityInspectorPopupOpened"
            @popup:closed="qualityInspectorPopupOpened = false">
            <worker-list
              title="选择质量员"
              :opened="qualityInspectorPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.qualityInspector">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="安全员" link="" @click="safeInspectorPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.safeInspector.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="safeInspectorPopupOpened"
            @popup:closed="safeInspectorPopupOpened = false">
            <worker-list
              title="选择安全员"
              :opened="safeInspectorPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.safeInspector">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="预算员" link="" @click="forecastInspectorPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.forecastInspector.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="forecastInspectorPopupOpened"
            @popup:closed="forecastInspectorPopupOpened = false">
            <worker-list
              title="选择预算员"
              :opened="forecastInspectorPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.forecastInspector">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item
          title="项目管理员"
          :link="manager.updateProjectManager ? true : false"
          @click="projectAdminPopupOpened = manager.updateProjectManager ? true : false">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.projectAdmin.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="projectAdminPopupOpened"
            @popup:closed="projectAdminPopupOpened = false">
            <worker-list
              title="选择项目管理员"
              :opened="projectAdminPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.projectAdmin">
            </worker-list>
          </f7-popup>
        </f7-list-item>
        <f7-list-item title="其他相关人员" link="" @click="relatPersonPopupOpened = true">
          <f7-icon icon="icon" slot="media"></f7-icon>
          <div class="item-after popup-smart-select">
            {{ manager.relatPerson.map(item => item.name).join(', ') }}
          </div>
          <f7-popup
            :opened="relatPersonPopupOpened"
            @popup:closed="relatPersonPopupOpened = false">
            <worker-list
              title="选择相关人员"
              :opened="relatPersonPopupOpened"
              :project-id.sync="projectId"
              :result.sync="manager.relatPerson">
            </worker-list>
          </f7-popup>
        </f7-list-item>
      </f7-list>
  </f7-page>
</template>
<script>
import { createToast } from '@/util/compUtils';
import { getManager, saveManager } from '@/api/project/manager';
import { Manager } from '@/model/reqObject';
import ManagerView from '@/components/ManagerView';
import WorkerList from '@/components/WorkerList';

export default {
  props: ['projectId'],
  components: {
    ManagerView,
    WorkerList,
  },
  data() {
    return {
      manager: new Manager(),
      dpmPopupOpened: false,
      forecastInspectorPopupOpened: false,
      pmPopupOpened: false,
      professionLeaderPopupOpened: false,
      projectAdminPopupOpened: false,
      qualityInspectorPopupOpened: false,
      safeInspectorPopupOpened: false,
      techLeaderPopupOpened: false,
      relatPersonPopupOpened: false,
      perms: {},
    };
  },
  mounted() {
    getManager({ projectId: this.projectId }).then((result) => {
      this.manager = new Manager(result.data);
      this.perms = result.perms || {};
    });
  },
  methods: {
    add() {
      const params = {
        companyId: this.manager.companyId || '',
        projectId: this.manager.projectId || this.projectId,
        dpm: (this.manager.dpm || []).map(item => item.id),
        forecastInspector: (this.manager.forecastInspector || []).map(item => item.id),
        pm: (this.manager.pm || []).map(item => item.id),
        professionLeader: (this.manager.professionLeader || []).map(item => item.id),
        projectAdmin: (this.manager.projectAdmin || []).map(item => item.id),
        qualityInspector: (this.manager.qualityInspector || []).map(item => item.id),
        safeInspector: (this.manager.safeInspector || []).map(item => item.id),
        techLeader: (this.manager.techLeader || []).map(item => item.id),
        relatPerson: (this.manager.relatPerson || []).map(item => item.id),
      };
      saveManager(params).then((data) => {
        if (data.code === 0) {
          createToast(this, '设置成功');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .popup-smart-select {
    max-width: 63%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/manager.vue